import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect";
import { flash_alert } from 'components/App';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button'
import MaterialTable from 'react-data-table-component';
import Radio from '@material-ui/core/Radio';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Link from '@material-ui/core/Link';
import {csrf, headers, money_format, date_event_format, date_difference_in_hours, api_token, site_url, payment_channel_label} from "constants/csrf"
import {useTranslation} from 'react-i18next';
import Skeleton from '@material-ui/lab/Skeleton';
import i18next from 'i18next'

const GET_SELECTED_SPARE_PARTS_REQUEST = "GET_SELECTED_SPARE_PARTS_REQUEST";
const GET_SELECTED_SPARE_PARTS_SUCCESS = "GET_SELECTED_SPARE_PARTS_SUCCESS";

function EditSparePartDialog({ row, customerProductId, onSuccess }) {
    const [open, setOpen] = useState(false);
    const [quantity, setQuantity] = useState(row.requested_quantity || row.quantity);

    function handleClickOpen(e) {
        e.preventDefault();
        setOpen(true);
    }

    function handleClose(e) {
        e.preventDefault();
        setOpen(false);
    }

    function handleQuantity(e) {
        const value = parseInt(e.target.value);
        if (value < 1 || value > 99) {
            flash_alert("Error", "Debe ingresar una cantidad entre 1 y 99", "error");
        } else {
            setQuantity(value);
        }
    }

    async function handleEdit(e) {
        e.preventDefault();
        setOpen(false);

        const body = {
            requested_quantity: quantity
        };

        console.log('=== EDITING SPARE PART ===');
        console.log('Spare part ID:', row.id);
        console.log('Current row data:', row);
        console.log('Sending body:', body);
        console.log('==========================');

        axios.patch(`/api/v1/customer_products/${customerProductId}/customer_product_requested_spare_parts/${row.id}`, body, {
            headers: headers
        })
            .then(response => {
                console.log('=== EDIT RESPONSE ===');
                console.log('Response data:', response.data);
                console.log('=====================');
                flash_alert("", "Refacción actualizada correctamente", "success");
                onSuccess();
            })
            .catch(error => {
                console.error(error);
                flash_alert("Error", "No se ha podido actualizar la refacción", "error");
            });
    }

    return (
        <React.Fragment>
            <Link href="#" className="mdl-navigation__link brand-primary-link sparepart-edit-link mg-r-15" onClick={handleClickOpen}>
                <i className="material-icons material-icons-20">edit</i> Editar
            </Link>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth={"sm"}
                onClose={handleClose}
            >
                <DialogTitle className="edit-sparepart-dialog-title">Editar refacción</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Grid container spacing={1}>
                            <Grid item xs={12} className="edit-sparepart-dialog-product-name">
                                {row.spare_part.name} ({row.spare_part.tnr})
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    InputProps={{ inputProps: { min: 1, max: 99 } }}
                                    label="Cantidad"
                                    name="quantity"
                                    value={quantity}
                                    onChange={handleQuantity}
                                />
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cerrar
                    </Button>
                    <Button onClick={handleEdit} variant="contained" color="primary" autoFocus>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

function DeleteSparePartDialog({ row, customerProductId, onSuccess }) {
    const [open, setOpen] = useState(false);

    function handleClickOpen(e) {
        e.preventDefault();
        setOpen(true);
    }

    function handleClose(e) {
        e.preventDefault();
        setOpen(false);
    }

    async function handleDelete(e) {
        e.preventDefault();
        setOpen(false);

        axios.delete(`/api/v1/customer_products/${customerProductId}/customer_product_requested_spare_parts/${row.id}`, {
            headers: headers
        })
            .then(response => {
                flash_alert("", "Producto eliminado correctamente", "success");
                onSuccess();
            })
            .catch(error => {
                console.error(error);
                flash_alert("Error", "No se ha podido eliminar el producto", "error");
            });
    }

    return (
        <React.Fragment>
            <Link href="#" className="mdl-navigation__link brand-primary-link product-delete-link" onClick={handleClickOpen}>
                <i className="material-icons">delete</i> Eliminar
            </Link>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle className="delete-sparepart-dialog-title">¿Está seguro que desea eliminar el producto?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        ¿Está seguro que desea eliminar el producto {row.spare_part.name} ({row.spare_part.tnr})?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button onClick={handleDelete} color="primary" autoFocus>
                        Sí
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

function getSparePartColumns(customerProductId, onRefresh, isReadOnly) {
    const columns = [
        {
          name: 'TNR',
          selector: 'spare_part.tnr',
          sortable: true,
          hide: 'sm',
        },
        {
          name: 'Nombre',
          selector: 'spare_part.name',
          sortable: true,
        },
        {
            name: 'Cantidad',
            selector: row => row.requested_quantity,
            sortable: true,
        },
    ];

    if (!isReadOnly) {
        columns.push({
            name: 'Acciones',
            selector: 'id',
            grow: true,
            minWidth: "190px",
            cell: row => (
                <span>
                    <EditSparePartDialog row={row} customerProductId={customerProductId} onSuccess={onRefresh} />
                    <DeleteSparePartDialog row={row} customerProductId={customerProductId} onSuccess={onRefresh} />
                </span>
            ),
        });
    }

    return columns;
}

function getSpareParts(customer_product_id, visit_id, setUserLoading) {
    return dispatch => {
        dispatch({type: GET_SELECTED_SPARE_PARTS_REQUEST});
        return fetch(`/api/v1/customer_products/${customer_product_id}/customer_product_requested_spare_parts?visit_id=${visit_id}`)
        .then(response => response.json())
        .then(json => {
            console.log('=== SPARE PARTS DATA RECEIVED ===');
            console.log('Full response:', json);
            if (json && json.length > 0) {
                console.log('First item structure:', json[0]);
                console.log('First item quantity field:', json[0].quantity);
                console.log('First item requested_quantity field:', json[0].requested_quantity);
            }
            console.log('=================================');
            dispatch(getSparePartsSuccess(json));
            setUserLoading(false);
            return json;
        })
        .catch(error => {
            console.log(error);
            setUserLoading(false);
        });
    };
};
export function getSparePartsSuccess(json) {
    return {
        type: GET_SELECTED_SPARE_PARTS_SUCCESS,
        json
    };
};

function refreshServiceSpareParts(service_id) {
    return dispatch => {
        fetch(`/api/v1/services/${service_id}/spare_parts`)
            .then(r => r.json())
            .then(json => dispatch({ type: 'GET_SPARE_PARTS_SUCCESS', json }))
            .catch(error => console.log(error));
    };
}

function refreshServiceRequestedSpareParts(service_id) {
    return dispatch => {
        fetch(`/api/v1/services/${service_id}/requested_spare_parts`)
            .then(r => r.json())
            .then(json => dispatch({ type: 'GET_REQUESTED_SPARE_PARTS_SUCCESS', json }))
            .catch(error => console.log(error));
    };
}

function VisitRequestedSpareParts(props){
    const {t} = useTranslation();
    const [checked, setChecked] = useState((props.visit.customer_products.length > 0 && props.visit.customer_products[0].id || ""));
    const [selectedCustomerProduct, setSelectedCustomerProduct] = useState((props.visit.customer_products && props.visit.customer_products[0] || {}));
    const [userLoading, setUserLoading] = useState(false);

    const [filterText, setFilterText] = useState("");
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [displayProductTable, setDisplayProductTable] = useState("block");
    const [productsPage, setProductsPage] = useState(1);
    const [productsPerPage, setProductsPerPage] = useState(10);
    const [productsTotal, setProductsTotal] = useState(0);
    const [isLoadingProducts, setIsLoadingProducts] = useState(false);

    const isServiceFinalizado = props.serviceStatusLabel === "Finalizado" || props.serviceStatusLabel === "Completado";
    const isVisitCompleted = props.visit.status === 'Visita completada';
    const canAddSpareParts = !isServiceFinalizado && !isVisitCompleted;

    console.log('VisitRequestedSpareParts - canAddSpareParts:', canAddSpareParts);
    console.log('VisitRequestedSpareParts - current_user:', props.current_user);
    console.log('VisitRequestedSpareParts - props.country:', props.country);

    const products_columns = [
        {
            name: 'TNR',
            selector: 'tnr',
            sortable: true,
            hide: 'sm',
        },
        {
            name: 'Nombre',
            selector: 'name',
            sortable: true,
        },
        {
            name: 'Precio',
            selector: 'price',
            sortable: true,
            hide: 'md',
            cell: row => (
                <span>
                    {money_format(row.country?.iso || props.country, row.price)}
                </span>
            ),
        }
    ];

    useEffect(() => {
        if(selectedCustomerProduct && selectedCustomerProduct.id){
            setUserLoading(true)
            props.getSpareParts(selectedCustomerProduct.id, props.visit.id , setUserLoading);
        } else {
            setUserLoading(false)
        }
    }, [selectedCustomerProduct]);

    useEffect(() => {
        if (canAddSpareParts && props.country) {
            fetchProducts(productsPage, productsPerPage, filterText, props.country);
        }
    }, []);

    function handleToggle(customer_product){
        setChecked(customer_product.id)
        setSelectedCustomerProduct(customer_product)
    }

    function fetchProducts(page, perPage, search, country) {
        setIsLoadingProducts(true);
        const url = `/api/v1/products?page=${page}&per_page=${perPage}&keywords=${search}&spare_parts=true&countries=${country}`;
        console.log('Fetching products from:', url);
        fetch(url)
            .then(response => {
                console.log('Products response status:', response.status);
                return response.json();
            })
            .then(json => {
                console.log('Products response data:', json);
                setProducts(json.data || []);
                setProductsTotal(json.total || 0);
                setIsLoadingProducts(false);
            })
            .catch(error => {
                console.error('Error fetching products:', error);
                setIsLoadingProducts(false);
            });
    }

    function handleFilterChange(text) {
        setFilterText(text);
        fetchProducts(1, productsPerPage, text, props.country);
    }

    function handleClearSearch() {
        setFilterText("");
        fetchProducts(1, productsPerPage, "", props.country);
    }

    function handleProductRowChange(state) {
        setSelectedProducts(state.selectedRows);
    }

    function handleProductsPageChange(newPage) {
        setProductsPage(newPage);
        fetchProducts(newPage, productsPerPage, filterText, props.country);
    }

    function handleProductsPerRowsChange(newPerPage, newPage) {
        setProductsPerPage(newPerPage);
        setProductsPage(newPage);
        fetchProducts(newPage, newPerPage, filterText, props.country);
    }

    function handleAddSpareParts() {
        if (selectedProducts.length === 0) {
            flash_alert("Error", "Debe seleccionar al menos un producto", "error");
            return;
        }

        if (!selectedCustomerProduct || !selectedCustomerProduct.id) {
            flash_alert("Error", "Debe seleccionar un producto del cliente", "error");
            return;
        }

        const body = {
            products: selectedProducts.map(p => p.id).join(','),
            customer_product_id: String(selectedCustomerProduct.id),
            quantities: selectedProducts.map(() => "1").join(','),
            warranties: selectedProducts.map(() => "false").join(',')
        };

        setIsLoadingProducts(true);

        axios.post(`/api/v1/visits/${props.visit.id}/request_spare_parts`, body, {
            headers: headers
        })
            .then(response => {
                flash_alert("", "Refacciones solicitadas exitosamente", "success");
                props.getSpareParts(selectedCustomerProduct.id, props.visit.id, setUserLoading);
                props.refreshServiceSpareParts(props.serviceID);
                props.refreshServiceRequestedSpareParts(props.serviceID);
                setSelectedProducts([]);
                setIsLoadingProducts(false);
            })
            .catch(error => {
                console.error(error);
                flash_alert("Error", "Error al solicitar refacciones", "error");
                setIsLoadingProducts(false);
            });
    }

	return (
		<React.Fragment>
            <p className="service-subtitle">{t('services.visits.productTableInfo.requestSpareParts')}</p>
            <List>
                {props.visit.customer_products && props.visit.customer_products.map((customer_product) => {
                    const listId = `list-visit-products-${props.visit.id}-${customer_product.id}`;
                    const labelId = `visit-products-${props.visit.id}-${customer_product.id}`;

                    return (
                    <ListItem key={listId} role={undefined} dense button onClick={() => handleToggle(customer_product)}>
                        <ListItemIcon className="service-address-label">
                        <FormControlLabel value={customer_product.id} control={<Radio color="primary"/>} label="" checked={checked == customer_product.id}
                            tabIndex={-1}
                        />
                        </ListItemIcon>
                        <ListItemText
                            id={labelId}
                            secondaryTypographyProps={{ component: 'div' }}
                            secondary={
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={4}>
                                        <span className="visit-summary-1">{t('services.visits.productTableInfo.name')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.product.name}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <span className="visit-summary-1">{t('services.visits.productTableInfo.tnr')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.product.tnr}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <span className="visit-summary-1">{t('services.visits.productTableInfo.id')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.serial_id}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <span className="visit-summary-1">{t('services.visits.productTableInfo.status')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.status}</span>
                                    </Grid>
                                </Grid>
                            }
                        />
                        
                    
                        <ListItemSecondaryAction>
                        
                        </ListItemSecondaryAction>
                    </ListItem>
                    );
                })}
                
                </List>
                <Grid style={{marginTop: "15px"}} container spacing={1}>
                    <Grid item xs={12}>
                        <MaterialTable
                            noHeader={true}
                            columns={getSparePartColumns(selectedCustomerProduct.id, () => {
                                if(selectedCustomerProduct && selectedCustomerProduct.id) {
                                    setUserLoading(true);
                                    props.getSpareParts(selectedCustomerProduct.id, props.visit.id, setUserLoading);
                                }
                                props.refreshServiceSpareParts(props.serviceID);
                                props.refreshServiceRequestedSpareParts(props.serviceID);
                            }, isServiceFinalizado || isVisitCompleted)}
                            data={props.spare_parts}
                            progressPending={userLoading}
                            progressComponent={<CircularProgress size={75} />}
                            responsive={true}
                            highlightOnHover={true}
                            striped={true}
                            contextMessage={{ singular: 'producto', plural: 'productos', message: 'seleccionados' }}
                            noDataComponent={i18next.t('globalText.NoDataComponent')}
                            paginationComponentOptions={{rowsPerPageText: i18next.t('globalText.rowsPerPageText'), rangeSeparatorText: i18next.t('globalText.rangeSeparatorText'), noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: i18next.t('globalText.selectAllRowsItemText') }}
                        />
                    </Grid>
                </Grid>

                {canAddSpareParts &&
                    <>
                        <Grid style={{marginTop: "30px"}} container spacing={1}>
                            <Grid item xs={12}>
                                <p className="service-subtitle">{t('services.visits.addSpareParts')}</p>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <Box component="span" display={displayProductTable} p={0} m={0} bgcolor="background.paper">
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel className="white-bg padding-sides-5 table-search-label" htmlFor="search">{t('globalText.filterFor')}</InputLabel>
                                        <OutlinedInput
                                            id="search"
                                            type="text"
                                            className="table-search-input"
                                            value={filterText}
                                            onChange={(e) => handleFilterChange(e.target.value)}
                                            endAdornment={
                                                <InputAdornment className="table-search-end" position="end">
                                                    <IconButton
                                                        aria-label="clear search"
                                                        onClick={handleClearSearch}
                                                    >
                                                        <Close />
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Grid container spacing={1} direction="row" justify="flex-end" alignItems="center">
                                    <Box component="span" display={displayProductTable} p={0} m={0} bgcolor="background.paper">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleAddSpareParts}
                                            disabled={selectedProducts.length === 0 || isLoadingProducts}
                                        >
                                            {t('services.visits.addSparePartsButton')}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Box component="span" display={displayProductTable} p={0} m={0} bgcolor="background.paper">
                                    <MaterialTable
                                        noHeader={true}
                                        columns={products_columns}
                                        data={products}
                                        progressPending={isLoadingProducts}
                                        progressComponent={<CircularProgress size={75} />}
                                        pagination
                                        paginationServer
                                        responsive={true}
                                        onChangeRowsPerPage={handleProductsPerRowsChange}
                                        onChangePage={handleProductsPageChange}
                                        onSelectedRowsChange={handleProductRowChange}
                                        paginationTotalRows={productsTotal}
                                        highlightOnHover={true}
                                        striped={true}
                                        selectableRows
                                        selectableRowsComponent={Checkbox}
                                        selectableRowsComponentProps={{ className: "product-checkbox", color: "primary" }}
                                        contextMessage={{ singular: 'producto', plural: 'productos', message: 'seleccionados' }}
                                        noDataComponent={i18next.t('globalText.NoDataComponent')}
                                        paginationComponentOptions={{rowsPerPageText: i18next.t('globalText.rowsPerPageText'), rangeSeparatorText: i18next.t('globalText.rangeSeparatorText'), noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: i18next.t('globalText.selectAllRowsItemText') }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                }
		</React.Fragment>
	);

}

const structuredSelector = createStructuredSelector({
    spare_parts: state => state.selected_spare_parts,
    page: state => state.page,
    perPage: state => state.perPage,
    total: state => state.total,
    current_user: state => state.current_user,
});
const mapDispatchToProps = {getSpareParts, refreshServiceSpareParts, refreshServiceRequestedSpareParts};
export default connect(structuredSelector, mapDispatchToProps)(VisitRequestedSpareParts)

